import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import Reveal from "./Reveal";

const FAQS = [
  { q: "Vad kostar fönsterputs?", a: "Priset beror på antal fönster, vald nivå och typ av fastighet. Därför får du alltid en kostnadsfri offert först – ett tydligt pris utan dolda avgifter, helt utan förpliktelser." },
  { q: "Vilka områden täcker ni?", a: "Vi hjälper privatpersoner och företag i hela Skaraborg, med utgångspunkt i Skövde." },
  { q: "Vad innebär Se Klart Ut-garantin?", a: "Är du inte helt nöjd med resultatet putsar vi om utan extra kostnad. Så säkra är vi på vår kvalitet." },
  { q: "Är ni försäkrade?", a: "Ja, vi är ansvarsförsäkrade. Du kan känna dig trygg när vi arbetar hemma hos dig eller i din verksamhet." },
  { q: "Vad betyder tillvalet 'Mellan fönstren'?", a: "Har du kopplade eller fyrsidiga fönster rengör vi även glasytorna mellan fönsterbågarna – ytan som annars är svår att komma åt. Tillvalet läggs till din valda nivå av fönsterputs." },
  { q: "Hur bokar jag?", a: "Välj nivå här på sidan eller skicka en kostnadsfri offertförfrågan – du kan också ringa oss direkt. Vi återkommer snabbt med ett tydligt prisförslag." },
];

export const FAQ = () => {
  const [open, setOpen] = useState(null);
  return (
    <section id="vanliga-fragor" className="bg-white scroll-mt-24" data-testid="faq-section">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-24 lg:py-32">
        <Reveal>
          <p className="text-xs font-semibold uppercase tracking-[0.22em] text-brand-blue">Vanliga frågor</p>
        </Reveal>
        <Reveal delay={0.06}>
          <h2 className="mt-4 font-heading text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-brand-ink leading-tight">
            Bra att veta innan du bokar
          </h2>
        </Reveal>
        <div className="mt-10 divide-y divide-slate-100 border-y border-slate-100">
          {FAQS.map((f, i) => {
            const isOpen = open === i;
            return (
              <div key={f.q}>
                <button
                  onClick={() => setOpen(isOpen ? null : i)}
                  aria-expanded={isOpen}
                  data-testid={`faq-accordion-item-${i}`}
                  className="w-full flex items-center justify-between gap-4 py-6 text-left group"
                >
                  <span className="text-base md:text-lg font-semibold text-brand-ink group-hover:text-brand-blue transition-colors">{f.q}</span>
                  <span className={`h-8 w-8 rounded-full flex items-center justify-center shrink-0 transition-all duration-300 ${isOpen ? "bg-brand-blue text-white rotate-45" : "bg-brand-iceBg text-brand-blue"}`}>
                    <Plus className="h-4 w-4" strokeWidth={2.5} />
                  </span>
                </button>
                <AnimatePresence initial={false}>
                  {isOpen && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.28, ease: [0.16, 1, 0.3, 1] }}
                      className="overflow-hidden"
                      data-testid={`faq-answer-${i}`}
                    >
                      <p className="pb-6 text-slate-600 leading-relaxed">{f.a}</p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
